import PropTypes from 'prop-types';
// @flow

import React from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import { Restaurant } from 'PMT/entities';
import { OrderSettings } from 'PMT/entities/order';

//
// components
//
import AbstractOrderSettingsForm from '../components/AbstractOrderSettingsForm';
import NumberOfDaysToProposeView from './components/NumberOfDaysToProposeView';
import PaymentModesView from './components/PaymentModesView';
import PaymentMethodsAllowed from './components/PaymentMethodsAllowed';

import Switch from 'react-bootstrap-switch';
import { Form } from 'react-bootstrap';
import FormGroupView from 'PMT/components/form/FormGroupView';
import PriceInput from 'PMT/components/form/PriceInput';
import TipTooltip from 'PMT/components/TipTooltip';

export default class OnSiteSettingsPage extends AbstractOrderSettingsForm {

  static propTypes = {
    restaurant: PropTypes.objectOf(Restaurant),

    orderSettings: PropTypes.objectOf(OrderSettings),

    onSubmit: PropTypes.func.isRequired,
  };

  state = this.getDefaultState(this.props.orderSettings);

  //
  //
  //

  onOnSiteAtBarEnabledChange = () => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.onSiteSettings.orderAtBarAvailable = !orderSettings.onSiteSettings.orderAtBarAvailable;
    this.onChangeOrderSettings(orderSettings);
  };

  onOnSitePreOrderEnabledChange = () => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.onSiteSettings.preOrderAvailable = !orderSettings.onSiteSettings.preOrderAvailable;
    this.onChangeOrderSettings(orderSettings);
  };

  onItemsSequencedEnabledChange = () => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.onSiteSettings.itemsSequenced = !orderSettings.onSiteSettings.itemsSequenced;
    this.onChangeOrderSettings(orderSettings);
  };

  onNumberOfDaysToProposeChange = (newValue: number) => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.onSiteSettings.setMaxTimeAheadWithDays(newValue);
    this.onChangeOrderSettings(orderSettings);
  };

  onChangeOnSitePaymentModesSettings = (newValue: PaymentModes) => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.onSiteSettings.onSite = newValue;
    this.onChangeOrderSettings(orderSettings);
  };

  onMinimumPriceChange = (minimumPrice: number) => {
    const orderSettings: OrderSettings = this.orderSettings;
    orderSettings.onSiteSettings.minimumPrice = minimumPrice;
    this.onChangeOrderSettings(orderSettings);
  };

  //
  // Renderers
  //

  renderAtBar() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.on_site.order_at_bar')}
        </FormGroupView.Label>
        <FormGroupView.Content>
          <Switch
            bsSize="mini"
            value={this.orderSettings.onSiteSettings.orderAtBarAvailable}
            onChange={this.onOnSiteAtBarEnabledChange}
            disabled={!this.canEditSettings()}
          />
        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  renderPaymentMethods() {
    return (
      <PaymentMethodsAllowed
        restaurant={this.props.restaurant}
        modeSettings={this.orderSettings.onSiteSettings}
        onClick={(value) => this.onPaymentMethodsChange(value, this.orderSettings.onSiteSettings)}
        disabled={!this.canEditSettings()}
      />
    );
  }

  renderMinimumPrice() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.on_site.minimum_price')}
        </FormGroupView.Label>
        <FormGroupView.Content>
          <PriceInput
            value={this.orderSettings.onSiteSettings.minimumPrice}
            onChange={this.onMinimumPriceChange}
            currencyCode={this.props.restaurant.currency}
            readOnly={!this.canEditSettings()}
          />
        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  renderNumberOfDaysToPropose() {
    return (
      <NumberOfDaysToProposeView
        numberOfDays={this.orderSettings.onSiteSettings.getMaxTimeAheadAsDays()}
        onChange={this.onNumberOfDaysToProposeChange}
        readOnly={!this.canEditSettings()}
      />
    );
  }

  renderPaymentsModes() {
    return (
      <PaymentModesView
        onSitePaymentModes={this.orderSettings.onSiteSettings.onSite}
        onChange={this.onChangeOnSitePaymentModesSettings}
        readOnly={!this.canEditSettings()}
      />
    );
  }

  renderPreOrder() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.on_site.pre_order_available')}
        </FormGroupView.Label>
        <FormGroupView.Content>
          <Switch
            bsSize="mini"
            value={this.orderSettings.onSiteSettings.preOrderAvailable}
            onChange={this.onOnSitePreOrderEnabledChange}
            disabled={!this.canEditSettings()}
          />
        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  renderItemsSequenced() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.itemsSequenced')}
          <TipTooltip
            text={I18n.tr('order.settings.itemsSequenced.tooltip')}
          />
        </FormGroupView.Label>
        <FormGroupView.Content>
          <Switch
            bsSize="mini"
            value={this.orderSettings.onSiteSettings.itemsSequenced}
            onChange={this.onItemsSequencedEnabledChange}
            disabled={!this.canEditSettings()}
          />
        </FormGroupView.Content>
      </FormGroupView>
    )
  }

  renderBody() {
    return (
      <Form horizontal>
        {this.renderAtBar()}
        {this.renderNumberOfDaysToPropose()}
        {this.renderPaymentMethods()}
        {this.renderMinimumPrice()}
        {this.renderPreOrder()}
        {this.renderItemsSequenced()}

        {/* <hr /> */}

        {/* {this.renderPaymentsModes()} */}

        <hr />

        {this.renderFixedButtons()}
      </Form>
    );
  }

  render() {
    return (
      <div>
        {this.renderBody()}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/order/settings/modes/OnSiteSettingsPage.js